import { render, staticRenderFns } from "./Year.vue?vue&type=template&id=d6996448&"
import script from "./Year.vue?vue&type=script&lang=ts&"
export * from "./Year.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports